export const uuidPossibleTypes = {
  "TypeWithUuidKey": [
    "Ac1CompanySiteConfig",
    "Ac1CompanySiteCredentialSetupConfig",
    "Ac1CredentialSetup",
    "Ac1Integration",
    "Ac1IntegrationCredentialSetup",
    "AccessGroup",
    "AccessPermit",
    "ActivityV2",
    "AdminNotification",
    "AiChatSuggestion",
    "AiConciergeChatSuggestion",
    "Apartment",
    "AppEdition",
    "Area",
    "Article",
    "Attribute",
    "BarrierControlAccess",
    "BarrierControlAccessConfig",
    "BarrierControlConfig",
    "BillingAddress",
    "BookableProduct",
    "BookableResource",
    "BookableResourceAddOn",
    "BookableResourceAddOnOption",
    "BookableResourceFeature",
    "BookableResourcePost",
    "BookableResourcePublic",
    "BookableResourceRoomConfiguration",
    "BookableResourceTypeV2",
    "Booking",
    "BookingAccessControlCode",
    "BookingAccessControlHistoryEvent",
    "BookingAddOn",
    "BookingAddOnOption",
    "BookingBlockOut",
    "BookingDiscount",
    "BookingPartialRefund",
    "BookingPaymentAdjustment",
    "BookingRoomConfiguration",
    "BookingSetting",
    "Building",
    "BuildingInfoCategory",
    "BuildingInfoPost",
    "BuildingLevel",
    "BuildingPublic",
    "BuildingTaxRate",
    "CMSArticle",
    "CMSSiteArticle",
    "Card",
    "CartDeliveryMethod",
    "Choice",
    "Client",
    "Comment",
    "Company",
    "CompanyAttribute",
    "CompanyIndustry",
    "CompanyV2",
    "ContentCollection",
    "ContentCollectionItem",
    "CreditAccount",
    "CreditCustomer",
    "CreditProvider",
    "CreditPurchasableItem",
    "CreditSubAccount",
    "CreditTransaction",
    "CreditTransactionDetail",
    "CriticalCommunication",
    "CriticalCommunicationAcknowledgement",
    "CriticalCommunicationPublicSummary",
    "CriticalCommunicationTemplate",
    "Deal",
    "DealVendor",
    "DeliveryLocation",
    "DeliveryMethod",
    "Destination",
    "DestinationChangeEvent",
    "DestinationDomainName",
    "DestinationIntegrations",
    "Discount",
    "DocumentRootPrefix",
    "EmailCommunication",
    "EmailCommunicationTemplate",
    "EmailCommunicationTheme",
    "EndUserGroup",
    "EventPost",
    "Feedback",
    "FeedbackQuestionResponse",
    "FlexOperator",
    "FlexTenant",
    "FlexTenantMembership",
    "FullProfile",
    "FullUser",
    "GroundfloorIntegration",
    "GroundfloorIntegrationForUser",
    "Invite",
    "Lease",
    "Level",
    "Like",
    "LineItem",
    "LineItemChoice",
    "LineItemMod",
    "Mod",
    "ModChoice",
    "NewsPost",
    "Occurrence",
    "OperationsCompany",
    "Order",
    "ParkingProduct",
    "PartialProfile",
    "PartialUser",
    "Permission",
    "PlainProduct",
    "PolicyChangeLogEvent",
    "Poll",
    "PollQuestion",
    "PollQuestionOption",
    "Portal",
    "Portfolio",
    "ProductCategory",
    "ProductSubscription",
    "Profile",
    "ProfileByChecksumEntry",
    "ProfileLogEvent",
    "PublicBookingAttendee",
    "PushNotification",
    "QuestionResponse",
    "QuickLink",
    "ReceptionNote",
    "ReceptionistNote",
    "ReconciliationReportBooking",
    "ReqMgtBuildingSchedule",
    "ReqMgtCafmConfiguration",
    "ReqMgtCategory",
    "ReqMgtCategoryCafmConfiguration",
    "ReqMgtCategoryPreset",
    "ReqMgtCategoryType",
    "ReqMgtCost",
    "ReqMgtCostActivity",
    "ReqMgtCostItem",
    "ReqMgtCostTax",
    "ReqMgtQueue",
    "ReqMgtRequest",
    "ReqMgtRequestAction",
    "ReqMgtRequestTimeTracking",
    "ReqMgtStatus",
    "ReqMgtSubCategory",
    "SavedSegment",
    "SavedSegmentV2",
    "SegmentationFilterItem",
    "Session",
    "SessionTemplate",
    "SessionV2",
    "Site",
    "SiteAttribute",
    "SiteGroup",
    "Space",
    "SubscriptionCharge",
    "SubscriptionProduct",
    "TaxRate",
    "TaxRegion",
    "TradingHour",
    "TradingHourV2",
    "UIWidget",
    "User",
    "Vendor",
    "VendorCategory",
    "ViciniteePass",
    "ViciniteePlace",
    "Visitor",
    "VisitorActivityHistory",
    "VisitorAppointment",
    "VisitorAppointmentBookingInfo",
    "VisitorAppointmentBookingResource",
    "VisitorAppointmentRecurringAppointment",
    "VisitorAppointmentRecurringInfo",
    "VisitorAppointmentResourceBuilding",
    "VisitorAppointmentResourceLevel",
    "VisitorHost",
    "VisitorReception",
    "VisitorReceptionist",
    "VisitorRecipient",
    "VisitorSuggestion",
    "VisitorType",
    "VmsBookableProduct",
    "VmsCartDeliveryMethod",
    "VmsChoice",
    "VmsDeal",
    "VmsDealVendor",
    "VmsDeliveryLocation",
    "VmsDeliveryMethod",
    "VmsDiscount",
    "VmsLineItem",
    "VmsLineItemChoice",
    "VmsLineItemMod",
    "VmsMod",
    "VmsModChoice",
    "VmsOrder",
    "VmsParkingProduct",
    "VmsPlainProduct",
    "VmsPolicy",
    "VmsPortal",
    "VmsProductCategory",
    "VmsProductSubscription",
    "VmsSession",
    "VmsSessionTemplate",
    "VmsSiteManagerInvitation",
    "VmsStorePermission",
    "VmsStoreUser",
    "VmsSubscriptionCharge",
    "VmsSubscriptionProduct",
    "VmsTaxRate",
    "VmsTaxRegion",
    "VmsTradingHour",
    "VmsTradingHourV2",
    "VmsVendor",
    "VmsVendorCategory",
    "VmsVendorUserInvitation",
    "Whitelabel"
  ]
};